import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

export const getTiposPagoGenerales = async () => {
    const respuesta = PrivateInterceptor('Base/Global/TiposPagoGeneral', 'GET')
    return respuesta
};